export default __webpack_public_path__ + "static/media/krist-rechtsanwälte.ba44914b.svg";